import { NOTIFY_SERVICE_NAMES } from './services';

export interface NotifyPayload {
  name: string;
  email: string;
  serviceKey: string;
  serviceName: string;
  pageUrl: string;
}

export function serviceContext(): Omit<NotifyPayload, 'name' | 'email'> {
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
  // Production pages use their final route parameter. The query parameter is
  // only a convenient context source for the standalone preview page.
  const routeKey = pathname.split('/').filter(Boolean).at(-1)?.toLowerCase() || '';
  const previewKey = new URLSearchParams(window.location.search).get('service')?.trim().toLowerCase();
  const serviceKey = routeKey === 'index.html' ? previewKey || '' : routeKey;
  const fallbackName = serviceKey
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

  return {
    serviceKey,
    serviceName: NOTIFY_SERVICE_NAMES[serviceKey] || fallbackName,
    // Preview parameters still submit a real, backend-approved booking URL.
    // Production pages derive their own URL and discard query/fragment data.
    pageUrl: previewKey
      ? `https://booking.thegpservice.co.uk/${serviceKey}`
      : `${window.location.origin}${pathname}`,
  };
}

export async function submitNotification(
  container: HTMLElement,
  contact: Pick<NotifyPayload, 'name' | 'email'>,
): Promise<void> {
  const apiBase = (container.dataset.apiBase || '/api').replace(/\/+$/, '');
  const response = await fetch(`${apiBase}/v1/clinic/notify-requests`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...contact, ...serviceContext() }),
  });

  if (!response.ok) throw new Error(`request failed: ${response.status}`);
}
